var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25031 16.5234H3.51593V7.69531H6.25031V16.5234ZM6.52313 4.88266C6.52313 3.99872 5.80597 3.28125 4.92249 3.28125C4.03564 3.28125 3.32031 3.99872 3.32031 4.88266C3.32031 5.76691 4.03564 6.48438 4.92249 6.48438C5.80597 6.48438 6.52313 5.76691 6.52313 4.88266ZM16.4844 11.6666C16.4844 9.29672 15.9837 7.53906 13.2153 7.53906C11.8851 7.53906 10.9921 8.20435 10.6276 8.89618H10.625V7.69531H7.96875V16.5234H10.625V12.1402C10.625 10.9923 10.9172 9.88022 12.3401 9.88022C13.7436 9.88022 13.7891 11.1929 13.7891 12.2131V16.5234H16.4844V11.6666ZM20 17.6562V2.34375C20 1.05133 18.9487 0 17.6562 0H2.34375C1.05133 0 0 1.05133 0 2.34375V17.6562C0 18.9487 1.05133 20 2.34375 20H17.6562C18.9487 20 20 18.9487 20 17.6562ZM17.6562 1.5625C18.087 1.5625 18.4375 1.91299 18.4375 2.34375V17.6562C18.4375 18.087 18.087 18.4375 17.6562 18.4375H2.34375C1.91299 18.4375 1.5625 18.087 1.5625 17.6562V2.34375C1.5625 1.91299 1.91299 1.5625 2.34375 1.5625H17.6562Z",
    fill: "#198282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.13852e9b481f85c93d8c933eafbacd16.svg";
export { ForwardRef as ReactComponent };